import { render } from "./EditClaimModal.vue?vue&type=template&id=3e8d5c74&scoped=true"
import script from "./EditClaimModal.vue?vue&type=script&lang=js"
export * from "./EditClaimModal.vue?vue&type=script&lang=js"

import "./EditClaimModal.vue?vue&type=style&index=0&id=3e8d5c74&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8d5c74"]])

export default __exports__